export default function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/nodes.js
// module id = 220
// module chunks = 0